export const SIMPLE = "SIMPLE";
export const SMS = "SMS";
export const SERVICES = "SERVICES";
export const HISOBOT = "HISOBOT";
